export const CROSS_SELL_CHARGER_FIELD_NAME = 'addedCrossSellCharger';
export const MISSING_CHARGER_STORAGE_KEY_PREFIX = 'activateMissingChargerForProductId_';
